import { useCallback } from "react";
import { $api } from "@babackapp/private-api-client/generated/client";
import { injectEmbedScript } from "./inject-embed-script";

type UseOpenReturnWidgetOptions = {
  /** Preview the V3 portal even when the shop has not opted into it. */
  forceNewWidget?: boolean;
};

export function useOpenReturnWidget(
  shopifyUrl: string,
  providerId: string,
  { forceNewWidget = false }: UseOpenReturnWidgetOptions = {},
) {
  const { refetch } = $api.useQuery(
    "get",
    "/embed-html",
    {
      params: { query: { shopifyUrl, autoOpen: true } },
      enabled: false,
    },
  );

  return useCallback(async () => {
    const w = window as unknown as Record<string, unknown>;
    const existingScript = document.querySelector("script[data-shop-id]");
    const isSameShop = existingScript?.getAttribute("data-shop-id") === providerId;

    if (w.babackReturnWidget) {
      if (isSameShop) {
        (w.babackReturnWidget as { open: () => void }).open();
        return;
      }

      // Widget was created for a different shop (staff switched shops in the
      // same tab) — tear it down so a fresh one loads for the current shop.
      (w.babackReturnWidget as { destroy: () => void }).destroy();
      delete w.babackReturnWidget;
      delete w.baback;
      delete w.__babackEmbedInit;
      existingScript?.remove();
    }

    const { data } = await refetch();
    if (!data?.shopId) return;
    injectEmbedScript(data, data.shopId, {
      noOverlayClose: false,
      forceNewWidget,
    });
  }, [refetch, providerId, forceNewWidget]);
}
